import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shared-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})

export class SharedLoadingComponent implements OnInit {

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/loading/loading.component.ts